import type { RouteRecordRaw, RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { logout as authLogout } from '@/modules/auth/auth';
import { reset as resetAnalytics } from '@/libs/analytics';
import { resetStore as resetVuexStore } from '@/store/resetStore';

export default [
  {
    path: '/logout',
    name: 'logout',
    async beforeEnter(
      _to: RouteLocationNormalized,
      _from: RouteLocationNormalized,
      next: NavigationGuardNext,
    ) {
      const path = await authLogout();
      resetVuexStore();
      resetAnalytics();
      next({ path });
    },
    component: () => h('div'),
  },
] satisfies RouteRecordRaw[];
